<template>
    <section class="pad-h-1">
        <div class="rel container pad-v-4 pad-h-1 mrg-v-2">
            <!--遮罩-->
            <matteWidget v-bind="matteData" />

            <h3 class="rel mrg-b-3">
                <span class="fsize-1d5 fsize-1-s">用户回访</span>
            </h3>
            <div class="rel container fsize-1d2 pad-h-1-s" sm>
                <form-widget v-bind="form.props" v-model="form.selected" />
            </div>
        </div>
        <article class="pad-b-10 pad-h-2 pad-t-5">
            <p class="fsize-1d7 fsize-1d5-s">{{packageName}}<br>{{footer_info.desc}}</p>
            <p>
                <a :href="footer_info.link" class="color-yellow fsize-1d3">{{footer_info.link}}</a><br>
                {{footer_info.end}}
            </p>
        </article>
    </section>
</template>

<script>
    import FormWidget from "@/components/BTXUI/form/form-widget"
    import matteWidget from "@/components/matte-widget"

    export default {
        name: "sec-form-widget",
        components: {
            FormWidget,
            matteWidget
        },
        props: ["title", "packageId", "packageName", "matteData"],
        data(){
            return {

                //表单填写内容
                form: {
                    props: {
                        formData: [
                            {
                                input_data: {
                                    type: "text",
                                    name: "dataset"
                                },
                                text: "感兴趣的数据",
                            },
                            {
                                input_data: {
                                    type: "text",
                                    name: "major"
                                },
                                text: "所在行业",
                            },
                            {
                                input_data: {
                                    type: "text",
                                    name: "contact"
                                },
                                text: "机构名称",
                            },
                            {
                                input_data: {
                                    type: "text",
                                    name: "mobile"
                                },
                                text: "手机号",
                            }
                        ],
                        layout: {
                            title_width: 10
                        },
                        submit: {
                            callback: this.$_send_log,
                            align: "center",
                            btn_data: {
                                btnText: "提交表单",
                                btnColor: {
                                    normal: {
                                        text: "#fff",
                                        bg: "dgray",
                                        line: "none",
                                    },
                                    hover: {
                                        text: "light",
                                        bg: "blue",
                                        line: "none",
                                    }
                                },
                                btnWidth: 14,
                                btnRound: true
                            },
                        }
                    },
                    selected: {},
                    submit_data: {}
                },

                //页脚信息
                footer_info: {
                    desc: "到清华 DaaS 数据库寻找数据支持",
                    link: "http://daas.2861.wiki",
                    end: "清华 DaaS"
                }

            }
        },
        methods: {

            //发送日志
            $_send_log(form_data, check_result){
                let send_data = new FormData();
                send_data.append("ip", this.$route.query.ip || "");
                send_data.append("client", window.navigator.userAgent);
                for(let pro in form_data){
                    send_data.append(pro, form_data[pro]);
                }
                this.$axios({
                    url: `${this.packageId}/log.html`,
                    method: "post",
                    data: send_data
                }).then(res=>{
                    let datas = res.data;
                    if(datas.code == 200){
                        this.$confirm.toast(datas.info, 3000, "success");
                    }
                })
            }

        },
        mounted(){
            document.title = this.title
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/sec-form-widget.vue